import classNames from 'classnames';
import { useTitle } from '../useTitle';

type Props = {
    title: string;
    class?: string;
    className?: string;
    style?: React.CSSProperties;
    children: React.ReactNode;
    fullWidth?: boolean;
};
export function Exercise({ title, fullWidth, ...props }: Props) {
    useTitle(title);
    return (
        <div
            {...props}
            className={classNames(
                props.class,
                props.className,
                'flex grow flex-col',
                {
                    'container-in-app': !fullWidth,
                },
            )}
        />
    );
}
